document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.vx-faq__list details').forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      item.parentElement.querySelectorAll('details[open]').forEach((other) => {
        if (other !== item) other.open = false;
      });
    });
  });
});
